export const type = 'setSavedOrder';

const setSavedOrder = (order) => ({
    type,
    payload: order,
});

export default setSavedOrder;